var TextfieldType;
(function (TextfieldType) {
    TextfieldType["Text"] = "text";
    TextfieldType["Email"] = "email";
    TextfieldType["Number"] = "number";
    TextfieldType["Password"] = "password";
})(TextfieldType || (TextfieldType = {}));
export { TextfieldType as T };
